import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';
import Icon from 'components/Icon';

export const EventXTastingProductsInfo: FC = () => {
    return (
        <div className={style.root}>
            <Icon className={style.icon} icon={'info-new-2'} />
            <Typography variant={'label-14-r'}>Набор вин на мероприятии с дегустацией может отличаться</Typography>
        </div>
    );
};
